"use client";

import React from "react";

export default function Footer() {
  const currentYear = 2026;

  return (
    <footer
      style={{
        background: "#0a0a0a",
        borderTop: "1px solid rgba(242,201,76,0.2)",
      }}
    >
      {/* Yellow divider */}
      <div
        style={{
          height: "2px",
          background: "linear-gradient(90deg, transparent, #F2C94C 30%, #29ABE2 70%, transparent)",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Main footer row */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-10">
          {/* Brand */}
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center font-display font-black text-sm"
                style={{ background: "#F2C94C", color: "#111111" }}
              >
                HH
              </div>
              <div>
                <p className="font-display font-black text-base text-white leading-none">Hi-Hats</p>
                <p className="text-xs" style={{ color: "rgba(255,255,255,0.35)" }}>Rajanukunte, Bengaluru</p>
              </div>
            </div>
            <p
              className="text-xs max-w-xs leading-relaxed"
              style={{ color: "rgba(255,255,255,0.35)" }}
            >
              Where music finds its voice. Guitar · Vocals · Art & Craft · Jamming Sessions.
            </p>
          </div>

          {/* Nav Links */}
          <div className="flex flex-wrap gap-x-8 gap-y-2">
            {[
              { label: "Home", href: "#home" },
              { label: "About", href: "#about" },
              { label: "Courses", href: "#courses" },
              { label: "Gallery", href: "#gallery" },
              { label: "Enroll", href: "#enroll" },
              { label: "Contact", href: "#contact" },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-display font-medium transition-colors"
                style={{ color: "rgba(255,255,255,0.45)" }}
                onMouseEnter={(e) => ((e.target as HTMLElement).style.color = "#F2C94C")}
                onMouseLeave={(e) => ((e.target as HTMLElement).style.color = "rgba(255,255,255,0.45)")}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Social Icons */}
          <div className="flex gap-3">
            {[
              { label: "Instagram", icon: "📸", href: "#" },
              { label: "YouTube", icon: "▶", href: "#" },
              { label: "Facebook", icon: "f", href: "#" },
              { label: "WhatsApp", icon: "W", href: "https://wa.me/919849007187" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Hi-Hats on ${s.label}`}
                className="social-icon w-9 h-9 rounded-full flex items-center justify-center text-sm font-display font-bold"
                style={{ color: "rgba(255,255,255,0.5)" }}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: "1px", background: "rgba(255,255,255,0.06)", marginBottom: "1.5rem" }} />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs" style={{ color: "rgba(255,255,255,0.3)" }}>
          <div className="flex flex-col sm:flex-row items-center gap-1 sm:gap-3 text-center sm:text-left">
            <span>© {currentYear} Hi-Hats Rajanukunte. All rights reserved.</span>
            <span className="hidden sm:inline" style={{ color: "rgba(255,255,255,0.15)" }}>·</span>
            <a
              href="mailto:varahistudios2024@gmail.com"
              className="contact-link"
              style={{ color: "rgba(255,255,255,0.3)" }}
            >
              varahistudios2024@gmail.com
            </a>
            <span className="hidden sm:inline" style={{ color: "rgba(255,255,255,0.15)" }}>·</span>
            <a
              href="tel:+919849007187"
              className="contact-link"
              style={{ color: "rgba(255,255,255,0.3)" }}
            >
              +91 98490 07187
            </a>
          </div>
          <div>
            Built by{" "}
            <a
              href="https://macford.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-display font-bold transition-colors"
              style={{ color: "#F2C94C" }}
              onMouseEnter={(e) => ((e.target as HTMLElement).style.textShadow = "0 0 16px rgba(242,201,76,0.5)")}
              onMouseLeave={(e) => ((e.target as HTMLElement).style.textShadow = "none")}
            >
              MACFORD DIGITAL
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}